import React from 'react';
import './chart-subtitles.less';

const ChartSubtitles = ({ subTitles = [] }) => {
  if (!subTitles.length) {
    return null;
  }
  return (
    <div className="chart-subtitles">
      {subTitles.map((subTitle, i) => (
        <div key={i}>{subTitle}</div>
      ))}
    </div>
  );
};

export default ChartSubtitles;
